// 封装ajax请求，方便统一处理接口返回值

import Vue from "vue";
import axios from "axios";
// import apiHelper from "apiHelper";

//需要统一处理的error
const erroCode = [-2];
const qs = require('qs');

//发送接口请求用时
let postApiTime = (url, startTime) => {
	try {
		url = url.replace(appConfig.apiBaseUrl, '');

		Vue.appCommonH.postTimeLine(1, {
			api: url.replace(appConfig.apiBaseUrl, ''),
			useTime: (new Date()).getTime() - startTime
		})
	} catch(error) {
	}
}

let getApi = (key)=>{
	var uri = Vue.appConfig.apis[key];
	console.log(uri,'uri');
	if(!uri) return "";

	if(process.env.NODE_ENV == "development") {
		return '/api' + uri;
	} else {
		return  uri;
	}
}

const appFetch = function (params, success, error) {
	var oldUrl = params.url;
	if (params === undefined) {
		console.error("必须传递参数");
		return false;
	}

	//去配置文件查找uri  增加筛选条件http--如果没有http 就进行封装方法修饰链接，有就直接用-用于直接填写api的控件
	if (params.url.toLocaleLowerCase().indexOf('http') < 0) {
		// params.url = getApi(params.url);
		// if(process.env.NODE_ENV == "development") {
		// 	params.url = '/api' + params.url;
		// } else {
		// 	params.url=  params.url;
		// }
	}
	// params.withCredentials = true;

	//设置默认header
	let defaultHeaders = {
		'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
	};

	//如果不是本地调试，则添加header头，以满足接口对请求类型的判断
	if (window.location.href.indexOf("local.") === -1) {
		defaultHeaders['X-Requested-With'] = 'XMLHttpRequest';
	}

	if (params.headers) {
		params.headers = {
			...defaultHeaders,
			...params.headers
		};
	} else {
		params.headers = defaultHeaders;
	}

	//参数统一用data,syf修改
	if (params.method.toLowerCase() == 'get') {
		params.params = params.data;
		delete params.data
	}

	if (params.data) {
		params.data = qs.stringify(params.data);
	}

	let startTime = (new Date()).getTime();
	return new Promise((resolve, reject) => {
		Vue.freeAjaxHelper.add();
		
		axios.defaults.baseURL = '/api/'

		axios(params)
			.then(function (response) {
				// postApiTime(params.url, startTime);
				let d = response.data || {};
				
				d.e = +d.e;
				if (d.e == 10042) { 
					Vue.authH.toLogin();
					return;
				} else if (d.e == 100421) {
          Vue.authH.loginOut();
					return;
        }else if (d.e == 10044) {
					Vue.prototype.$message({
						type: "error",
						message: d.m,
						showClose: true
					});
				} else {
					success && success(response.data);
					resolve(response.data)
				}
			})
			.catch(function (err) {
				// postApiTime(params.url, startTime);
				if(err.message !== 'Request aborted') {
					error && error(err.response && err.response.data.msg)
					reject(err);
				}
			}).finally(() => {
				Vue.freeAjaxHelper.reduce();
			})
	});
}

export { appFetch };
